module.exports = __webpack_public_path__ + "img/3.8c6a6656.png";